import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type AIAssistantPositionType = 'side' | 'full' | 'window';

interface IAIAssistantPositionState {
  isOpen: boolean;
  position: AIAssistantPositionType;
}

const initialState: IAIAssistantPositionState = {
  isOpen: false,
  position: 'side'
};

export const aiAssistantPosition = createSlice({
  name: 'aiAssistantPosition',
  initialState,
  reducers: {
    reducerUpdateOpenAIAssistant: (
      state: IAIAssistantPositionState,
      action: PayloadAction<boolean>
    ) => {
      state.isOpen = action.payload;
    },
    reducerUpdatePositionAIAssistant: (
      state: IAIAssistantPositionState,
      action: PayloadAction<AIAssistantPositionType>
    ) => {
      state.position = action.payload;
    }
  }
});

export const {
  reducerUpdateOpenAIAssistant,
  reducerUpdatePositionAIAssistant
} = aiAssistantPosition.actions;

export default aiAssistantPosition.reducer;
